import {
  Grid,
  Box,
  Typography,
  Button,
} from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";

  const AmpliaglIcon = () => {
    return (
      <svg width="34" height="34" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.3233 44.625C22.8544 44.9018 23.1261 45.0462 23.4966 45.1184C23.7931 45.1786 24.213 45.1786 24.4971 45.1184C24.8676 45.0462 25.1394 44.9018 25.6705 44.625C30.3392 42.1698 43.1969 34.4553 43.1969 23.8524V13.5263C43.1969 11.7933 43.1969 10.9388 42.8881 10.1926C42.6164 9.54272 42.1594 8.953 41.5789 8.48363C40.9119 7.95409 40.0226 7.65321 38.2193 7.05146L25.337 2.7068C24.8429 2.53831 24.5836 2.45406 24.3365 2.41795C24.1142 2.39388 23.8795 2.39388 23.6449 2.41795C23.3855 2.45406 23.1385 2.53831 22.6444 2.7068L9.77442 7.05146C7.98349 7.65321 7.08185 7.96612 6.41489 8.48363C5.83438 8.953 5.37738 9.53068 5.10566 10.1926C4.79688 10.9388 4.79688 11.7933 4.79688 13.5263V23.8524C4.79688 34.4553 17.6422 42.1698 22.3233 44.625Z" stroke="#EBB349" strokeLinecap="round" strokeLinejoin="round"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M23.4338 13.4906C23.8516 12.6665 24.9946 12.6665 25.4002 13.4906L27.6984 18.017C27.723 18.0785 27.7844 18.1154 27.8459 18.1277L32.6759 19.0132C33.5485 19.1731 33.8926 20.2678 33.2904 20.9197L29.8614 24.6342C29.8246 24.6834 29.8 24.7449 29.8123 24.7941L30.5005 29.8986C30.6234 30.8088 29.7017 31.4852 28.9028 31.0793L24.4293 28.7916L19.9557 31.0793C19.1568 31.4852 18.2351 30.8088 18.358 29.8986L19.0462 24.7941C19.0462 24.7326 19.0462 24.6711 18.9971 24.6342L15.5682 20.9197C14.966 20.2555 15.3101 19.1731 16.1827 19.0132L21.0126 18.1277C21.0741 18.1277 21.1232 18.0785 21.1601 18.017L23.4584 13.4906H23.4338ZM26.7521 18.6442L24.417 14.0195L22.0819 18.6442C21.9221 18.964 21.6271 19.1731 21.2953 19.2469L16.7357 20.0833C16.5759 20.1079 16.5145 20.3047 16.6251 20.4277L19.8697 23.9455C20.1032 24.1915 20.2138 24.5482 20.1646 24.8925L19.5133 29.7141C19.4887 29.874 19.6607 29.997 19.8082 29.9232L23.9377 27.8076C24.2449 27.6477 24.6136 27.6477 24.9332 27.8076L29.0626 29.9232C29.2101 29.997 29.3821 29.874 29.3576 29.7141L28.7062 24.8925C28.657 24.5482 28.7676 24.2038 29.0011 23.9455L32.2457 20.4277C32.3563 20.3047 32.2949 20.1202 32.1351 20.0833L27.5755 19.2469C27.2314 19.1854 26.9487 18.964 26.7889 18.6442H26.7521Z" fill="#EBB349"/>
      </svg>
    );
  }

  const PremiumIcon = () => {
    return (
      <svg width="34" height="34" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.3233 45.0558C22.8544 45.3355 23.1261 45.4814 23.4966 45.5543C23.7931 45.6151 24.213 45.6151 24.4971 45.5543C24.8676 45.4814 25.1394 45.3355 25.6705 45.0558C30.3392 42.5756 43.1969 34.7824 43.1969 24.0713V13.6399C43.1969 11.8891 43.1969 11.0259 42.8881 10.2721C42.6164 9.61561 42.1594 9.01987 41.5789 8.54571C40.9119 8.01076 40.0226 7.70682 38.2193 7.09892L25.337 2.70993C24.8429 2.53972 24.5836 2.45461 24.3365 2.41814C24.1142 2.39382 23.8795 2.39382 23.6449 2.41814C23.3855 2.45461 23.1385 2.53972 22.6444 2.70993L9.77442 7.09892C7.98349 7.70682 7.08185 8.02292 6.41489 8.54571C5.83438 9.01987 5.37738 9.60345 5.10566 10.2721C4.79688 11.0259 4.79688 11.8891 4.79688 13.6399V24.0713C4.79688 34.7824 17.6422 42.5756 22.3233 45.0558Z" stroke="#EBB349" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M34.2152 30.4001H13.8608C13 30.4001 12.2532 29.7972 12.0759 28.943L12 17.6001L17.9367 22.7L23.9241 17.6001L29.6582 22.7L35.8608 17.6001L36 28.8802C35.8608 29.7595 35.1013 30.4001 34.2025 30.4001H34.2152Z" stroke="#EBB349" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M23.5938 17.6001C24.6983 17.6001 25.5938 16.7047 25.5938 15.6001C25.5938 14.4955 24.6983 13.6001 23.5938 13.6001C22.4892 13.6001 21.5938 14.4955 21.5938 15.6001C21.5938 16.7047 22.4892 17.6001 23.5938 17.6001Z" stroke="#EBB349" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M34.7969 17.6001C35.9014 17.6001 36.7969 16.7047 36.7969 15.6001C36.7969 14.4955 35.9014 13.6001 34.7969 13.6001C33.6923 13.6001 32.7969 14.4955 32.7969 15.6001C32.7969 16.7047 33.6923 17.6001 34.7969 17.6001Z" stroke="#EBB349" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13.1953 17.6001C14.2999 17.6001 15.1953 16.7047 15.1953 15.6001C15.1953 14.4955 14.2999 13.6001 13.1953 13.6001C12.0907 13.6001 11.1953 14.4955 11.1953 15.6001C11.1953 16.7047 12.0907 17.6001 13.1953 17.6001Z" stroke="#EBB349" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }

  const AmpliaIcon = () => {
    return (
      <svg width="34" height="34" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.8906 23.5033L22.2515 30.3596L36.5666 14.9268" stroke="#EBB349" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22.3233 45.51C22.8544 45.7926 23.1261 45.94 23.4966 46.0138C23.7931 46.0752 24.213 46.0752 24.4971 46.0138C24.8676 45.94 25.1394 45.7926 25.6705 45.51C30.3392 43.0034 43.1969 35.1272 43.1969 24.3021V13.7595C43.1969 11.9902 43.1969 11.1178 42.8881 10.3559C42.6164 9.69243 42.1594 9.09035 41.5789 8.61114C40.9119 8.0705 40.0226 7.76332 38.2193 7.14895L25.337 2.71323C24.8429 2.54121 24.5836 2.4552 24.3365 2.41833C24.1142 2.39376 23.8795 2.39376 23.6449 2.41833C23.3855 2.4552 23.1385 2.54121 22.6444 2.71323L9.77442 7.14895C7.98349 7.76332 7.08185 8.08279 6.41489 8.61114C5.83438 9.09035 5.37738 9.68014 5.10566 10.3559C4.79688 11.1178 4.79688 11.9902 4.79688 13.7595V24.3021C4.79688 35.1272 17.6422 43.0034 22.3233 45.51Z" stroke="#EBB349" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }

  const getIconByTitle = (title) => {
    switch (title) {
      case "PREMIUM":
        return <PremiumIcon />;
      case "AMPLIA GL":
        return <AmpliaglIcon />;
      case "AMPLIA":
        return <AmpliaIcon />;
      default:
        return null;
    }
  };

  const CoverageCardHeader = ({ title }) => {
    return (
        <Grid container alignItems="center" spacing={1}>
          <Grid size={{ xs: 12, md: 12}}
            sx={{
              display: 'flex',
              justifyContent: 'center'
            }}>
            <Box sx={{ 
              width: 36, 
              height: 36 
            }}>
              {getIconByTitle(title)}
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 12}}>
            <Typography variant="h6" 
              sx={{ 
                fontWeight: "bold",
                textAlign: "center"
              }}>
              {title}
            </Typography>
          </Grid>
        </Grid>
    );
  };


const CoverageCard = ({ title, features = [], price, onSelect }) => {
  const formattedPrice = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);

  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        p: 2,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "space-between",
        maxWidth: {
          md: 240,
        },
      }}
    >
      <Grid container direction="column" sx={{ height: "100%" }}>
        <CoverageCardHeader title={title} />
        <Grid>
          <Box sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 2,
              borderBottom: "0.5px solid #c4c4c4"
            }}>
            <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <Typography sx={{ fontSize: "1rem", color: "#181818", fontWeight: 600 }}>
                {formattedPrice}
              </Typography>
              <Typography sx={{ fontSize: "1rem", color: "#181818", fontWeight: 500}}>
                &nbsp;MXN/AÑO
              </Typography>
            </Box>
            <Button
              variant="contained"
              fullWidth
              onClick={onSelect}
              sx={{
                bgcolor: "#181818",
                color: "#ffff",
                mt: 2,
                mb: 2,
                py: 1.5,
                "&:hover": { 
                  bgcolor: "#4d4d4d",
                  boxShadow: "none",
                },
                boxShadow: "none",
                borderRadius: 0,
                fontWeight: "normal",
                fontSize: "0.85rem"
              }}
            >
              Elegir y Continuar
            </Button>
          </Box>
        </Grid>
        <Grid sx={{ flexGrow: 1, mt: 2 }}>
          {features.map((feature, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 1,
                mb: 1
              }}
            >
              <CheckIcon 
                sx={{ 
                  color: "#4d4d4d", 
                  fontSize: 18, 
                  mt: 0.25 
                }} 
              />
              <Typography 
                sx={{ 
                  fontSize: "0.85rem", 
                  color: "#4d4d4d",
                  lineHeight: 1.6
                }}
              >
                {feature}
              </Typography>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default CoverageCard;
